export default {
  SET_ACCOUNT_TREND_LIST(state, params) {
    state.accountTrendList = params;
  },
  SET_ACCOUNT_DIFF_LIST(state, params) {
    state.accountDiffList = params;
  },
  SET_ACCOUNT_STATUS_LIST(state, params) {
    state.accountStatusList = params;
  },
  SET_ACCOUNT_CSP_STATUS_LIST(state, params) {
    state.accountCspStatusList = params;
  },
}



// WEBPACK FOOTER //
// ./src/vuex/monitoring/cloudaccount/summary/accountDivisionMutation.js